import type { OrganizationTag, TagSuggestion } from "../types"
import { normalizeTag, normalizeTags } from "./tagNormalization"

export function buildTagColorMap(
  suggestions: readonly TagSuggestion[],
): Record<string, string | null> {
  const map: Record<string, string | null> = {}
  for (const suggestion of suggestions) {
    map[normalizeTag(suggestion.tag)] = suggestion.color ?? null
  }
  return map
}

export function buildOrganizationTagsByName(
  tags: readonly OrganizationTag[],
): Record<string, OrganizationTag> {
  const map: Record<string, OrganizationTag> = {}
  for (const tag of tags) {
    map[normalizeTag(tag.name)] = tag
  }
  return map
}

export function buildTagFilterItems({
  selectedTags,
  suggestions,
}: {
  selectedTags: readonly string[]
  suggestions: readonly TagSuggestion[]
}): TagSuggestion[] {
  const byName = new Map<string, TagSuggestion>()

  for (const suggestion of suggestions) {
    const tag = normalizeTag(suggestion.tag)
    if (tag) {
      byName.set(tag, { ...suggestion, tag })
    }
  }

  for (const tag of normalizeTags(selectedTags)) {
    if (!byName.has(tag)) {
      byName.set(tag, { tag, color: null })
    }
  }

  return Array.from(byName.values()).sort((a, b) => a.tag.localeCompare(b.tag))
}
